import { FullPolicyData } from 'interfaces/customerDataTypes';
import blueBuilding from 'assets/images/light-blue-building.png';
import blueBuildingMobile from 'assets/images/light-blue-building-mobile.png';
import { useGetScreenSize } from 'utils';

import './dashboardTitle.scss';

interface DashboardTitleProps {
  title: string;
  selectedPolicy: FullPolicyData;
  id?: string;
}

export const DashboardTitle = ({ title, id, selectedPolicy }: DashboardTitleProps): JSX.Element => {
  const { isMobile, isTablet } = useGetScreenSize();

  const getDashboardImage = (): JSX.Element => {
    if (isMobile) {
      return <img src={blueBuildingMobile} height={201} width={211} alt="Building title image"></img>;
    }

    if (isTablet) {
      return <img src={blueBuildingMobile} height={361} width={386} alt="Building title image"></img>;
    }

    return <img src={blueBuilding} height={384} width={682} alt="Building title image"></img>;
  };

  return (
    <div className="dashboard-title">
      <div>
        <h1 className="text" id={id || 'dashboard-title'}>
          {title.toLocaleUpperCase()}
        </h1>
        <p className="text">
          {selectedPolicy.title} {selectedPolicy.forename} {selectedPolicy.surname}
        </p>
      </div>
      {getDashboardImage()}
    </div>
  );
};
